// extracted by mini-css-extract-plugin
export default {"noPaddingBottom":"noPaddingBottom---M3z6r"};